import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  SettingsFilterStringType,
  SettingsTypes,
} from '../../containers/SettingsPage/types';
import {
  setFilteredOptions,
  settingsOptionsSelectors,
} from '../../reducers/entitySettingsOptionsSlice';
import {
  entitySettingsSelectors,
  setFilterSetting,
} from '../../reducers/entitySettingsSlice';
import { useAppSelector } from '../../reducers/rootReducer';
import { compareArraysValues } from '../utils';

export function useSettingsAstronautDraft(
  farmAstronauts: SettingsTypes.FarmAstronaut[],
) {
  const dispatch = useDispatch();

  const filteredAstronautOptions = useAppSelector(
    settingsOptionsSelectors.selectFilteredAstronautOptions,
  );
  const committed = useMemo(
    () => filteredAstronautOptions.map((astr) => astr.externalId),
    [filteredAstronautOptions],
  );
  const filterString = useAppSelector(
    entitySettingsSelectors.selectFilterString,
  );

  const [draft, setDraft] = useState<string[]>(() => committed);

  useEffect(() => {
    setDraft((currentDraft) =>
      compareArraysValues(currentDraft, committed) ? currentDraft : committed,
    );
  }, [committed]);

  const dirty = !compareArraysValues(committed, draft);

  const apply = useCallback(() => {
    if (compareArraysValues(committed, draft)) {
      return;
    }

    const filteredOptions = farmAstronauts.filter((astronaut) =>
      draft.includes(astronaut.externalId),
    );

    if (
      !Object.keys(SettingsFilterStringType).includes(filterString) &&
      !filteredOptions.map((filter) => filter.name).includes(filterString)
    ) {
      dispatch(setFilterSetting(SettingsFilterStringType.None));
    }

    dispatch(setFilteredOptions(filteredOptions));
  }, [committed, dispatch, draft, farmAstronauts, filterString]);

  const discard = useCallback(() => {
    setDraft(committed);
  }, [committed]);

  return { draft, setDraft, dirty, apply, discard };
}

export default useSettingsAstronautDraft;
